<template>
  <section>
    <label
      ><small
        v-show="boardColumns.required"
        class="text-danger"
        >*</small
      >
      Colunas:</label
    >
    <div class="input-group">
      <b-form-select
        @change="emitBoardAndColumn()"
        :required="boardColumns.required"
        v-model="boardColumns.value"
        :options="boardColumns.listOptions"
        placeholder="Selecione a coluna"
        class="w-100"
        label="text"
      >
        <template v-slot:no-options>Nenhuma coluna encontrada.</template>
      </b-form-select>
    </div>
  </section>
</template>
<script>
import BoardRepositoryV2 from '@/shared/http/repositories/crm/board_v2.js'

export default {
  name: 'SelectBoardColumn',
  props: {
    boardId: {
      type: Number | String,
      required: true,
      default: null
    },
    selectedOption: {
      type: Number | String,
      required: false,
      default: null
    }
  },
  data () {
    return {
      boardColumns: { listOptions: [], value: null, required: true }
    }
  },
  created () {
    this.loadColumns()
  },
  watch: {
    selectedOption: {
      immediate: true,
      handler: function (newVal) {
        this.boardColumns.value = newVal
      }
    }
  },
  methods: {
    loadColumns () {
      BoardRepositoryV2.Column_GetAllActive(this.boardId)
        .then((res) => {
          let sortedContent = res.data.content.sort(
            (a, b) => a.posicao - b.posicao
          )
          let options = sortedContent
            .filter((x) => x.id != null && x.inative !== true)
            .map((x) => ({ value: x.id, text: x.nome }))
          this.boardColumns.listOptions = options
        })
        .catch(this.onException)
    },
    emitBoardAndColumn () {
      this.$emit('onSelect', [this.boardId, this.boardColumns.value])
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/forms/selects/SelectBoardColumn.vue